
// src/contentfulClient.js
import { createClient } from 'contentful';


// Initialize the Contentful client with environment variables
let client;
try {
  console.log('ENV VARS -', {
    space:process.env.REACT_APP_CONTENTFUL_SPACE_ID, // Your space ID
    accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN, // Your access token
    environment: process.env.REACT_APP_ENV, // Optional: specify environment, default is 'master'
  })
  client = createClient({
    space:process.env.REACT_APP_CONTENTFUL_SPACE_ID, // Your space ID
    accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN, // Your access token
    environment: process.env.REACT_APP_ENV, // Optional: specify environment, default is 'master'
  });
} catch (error) {
  console.error('Error initializing Contentful client:', error);
}

export default client;
